import React, { useState, useEffect } from "react";
import { Icon } from "tabler-react";
import { Crud_Catalogos } from '../../../herramientas/Crud_Catalogos';
import Select from "react-select";
import { NotificationManager } from 'react-notifications';

const currentUser = sessionStorage.getItem("currentUser") !== null
  ? JSON.parse(sessionStorage.getItem("currentUser"))
  : {};

const SoftphoneV3 = ({ elementos }) => {
  const [softphonePlataformas, setSoftphonePlataformas] = useState([]);
  const [softphonePlataforma, setSoftphonePlataforma] = useState({});
  const [plataformas, setPlataformas] = useState([]);
  const [plataforma, setPlataforma] = useState({ value: 0, label: "Seleccionar plataforma", data: {} });
  const [grupo, setGrupo] = useState({ value: 0, label: "Selecciona un grupo", data: {} });
  const [configuracion, setConfiguracion] = useState({
    grupo: "",
    extension: "",
    username: "",
    password: "",
    descripcion: "",
    estatus: false
  });
  const [agente, setAgente] = useState({
    name: "",
    lastname: "",
    username: "",
    password: "",
    email: "",
    role: "AGENTE",
    grupo: 0,
    recording: 1
  });
  const [editar, setEditar] = useState(false);

  // Base URL para el controlador V3 (unifica proveedores 1, 2, 3 y 4)
  const API_BASE = "softphone_v3";

  useEffect(() => {
    getfuntion("get", "", "", "softphone_configuracion", "softphone_configuracion_all");
  }, []);

  useEffect(() => {
    if (softphonePlataformas && softphonePlataformas.length) {
      let plataformasTemp = [{ value: 0, label: "Seleccionar plataforma", data: {} }];
      for (let pltUser of currentUser) {
        if (softphonePlataformas.find(sp => sp.id === pltUser.plataforma.id)) {
          plataformasTemp.push({
            value: pltUser.plataforma.id,
            label: pltUser.plataforma.nombre,
            data: pltUser.plataforma
          });
        }
      }
      setPlataformas(plataformasTemp);
      getfuntion("get", "", "", API_BASE + "/" + elementos.id, "configuracion");
    }
  }, [softphonePlataformas]);

  useEffect(() => {
    if (softphonePlataforma && softphonePlataforma.softphoneConfiguracionId) {
      getfuntion("get", "", "", API_BASE + "/grupos/" + softphonePlataforma.softphoneConfiguracionId, "grupos");
    }
  }, [softphonePlataforma]);

  useEffect(() => {
    if (plataforma.value) {
      getfuntion("get", "", "", "softphone_configuracion/" + plataforma.value, "softphone_configuracion");
    }
  }, [plataforma]);

  useEffect(() => {
    if (configuracion.id && editar) {
      setConfiguracion({
        ...configuracion,
        grupo: softphonePlataforma.idGrupo,
        grupoExtension: softphonePlataforma.extension
      });
    }
  }, [softphonePlataforma]);

  const getfuntion = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {
    return Crud_Catalogos(catalogo, "usuario", metodo, id, obj, "", stateVar, hiddenModl, [])
      .then((returnVal) => {
        switch (metodo) {
          case "get":
            if (stateVar === "softphone_configuracion_all") {
              setSoftphonePlataformas(returnVal || []);
            }
            if (stateVar === "softphone_configuracion") {
              if (returnVal && returnVal.id) {
                setSoftphonePlataforma(returnVal);
              }
            }
            if (stateVar === "grupos") {
              if (returnVal.data && returnVal.data.length) {
                const grupoTemp = returnVal.data.find(g => g.id === softphonePlataforma.idGrupo);
                setGrupo(grupoTemp);
                setAgente({ ...agente, grupo: grupoTemp ? grupoTemp.id : 0 });
              }
            }
            if (stateVar === "configuracion") {
              if (returnVal.id) {
                setConfiguracion(returnVal);
                setAgente({
                  name: elementos.persona.nombre,
                  lastname: elementos.persona.aPaterno + " " + elementos.persona.aMaterno,
                  username: returnVal.username,
                  password: "",
                  email: elementos.persona.correo,
                  role: "AGENTE",
                  grupo: 0,
                  recording: 1
                });
                setEditar(false);
                getfuntion("get", "", "", "softphone_configuracion/" + returnVal.idPlataforma, "softphone_configuracion");
              } else {
                setConfiguracion({
                  grupo: "",
                  extension: "",
                  username: cleanUsername(elementos.username),
                  password: "",
                  descripcion: "",
                  estatus: false
                });
                setAgente({
                  name: elementos.persona.nombre,
                  lastname: elementos.persona.aPaterno + " " + elementos.persona.aMaterno,
                  username: cleanUsername(elementos.username),
                  password: "",
                  email: elementos.persona.correo,
                  role: "AGENTE",
                  grupo: 0,
                  recording: 1,
                  predictive: 0
                });
                setEditar(true);
              }
            }
            break;
          case "post":
            if (stateVar === "crear_agente") {
              if (returnVal.status === 200 || returnVal.status === 201) {
                setConfiguracion(returnVal.data);
                NotificationManager.success("Guardado correctamente", "Nuevo");
                setEditar(false);
              } else {
                NotificationManager.error(returnVal.message, "Nuevo");
              }
            }
            break;
          case "put":
            if (stateVar === "configuracion") {
              if (returnVal.status === 200) {
                setConfiguracion(returnVal);
                NotificationManager.success("Guardado correctamente", "Actualizar", 20000);
                setEditar(false);
              } else {
                NotificationManager.error("Error al actualizar configuración", "Actualizar");
              }
            }
            break;
          case "delete":
            if (stateVar === "configuracion") {
              NotificationManager.success("Información reseteada", "Remover");
              getfuntion("get", "", "", API_BASE + "/" + elementos.id, "configuracion");
              setEditar(true);
            }
            break;
          default:
            break;
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const cleanUsername = (u) => {
    let usernameTemp = u;
    usernameTemp = usernameTemp.toLowerCase();
    usernameTemp = usernameTemp.replace(/\s/g, '');
    usernameTemp = usernameTemp.replace(/[^a-zA-Z0-9 ]/g, '.');
    return usernameTemp;
  };

  return (
    <div>
      <div className="row" style={{ height: "100%" }}>
        <div className="col-12">
          <h4>Configuración de Softphone</h4>
          <p>Esta información enlazará su teléfono al sistema de telefonía (v3 - unificado)</p>
          <form>
            {configuracion.id && !editar || plataforma.value ? (
              <div className="form-group">
                <label>
                  Su central es: {grupo?.name}, su extensión es: {grupo?.extension}
                </label>
              </div>
            ) : (
              <div className="form-group">
                <label>Plataforma</label>
                <Select
                  value={plataforma}
                  options={plataformas}
                  onChange={(e) => setPlataforma(e)}
                  isDisabled={configuracion.id && !editar}
                />
                <small className="form-text text-muted">
                  {plataformas.length > 2
                    ? "Tienes más de una plataforma asignada. Selecciona en cuál generar tu extensión."
                    : ""}
                </small>
              </div>
            )}

            <div className="form-group">
              <label>Username</label>
              <input
                type="text"
                className="form-control"
                placeholder="user"
                disabled={configuracion.id}
                value={configuracion.username || ""}
                autoComplete="off"
                onChange={(e) => {
                  setConfiguracion({ ...configuracion, username: cleanUsername(e.target.value) });
                  setAgente({ ...agente, username: cleanUsername(e.target.value) });
                }}
              />
              <small className="form-text text-muted">
                Nombre de usuario para ingresar al sistema de telefonía
              </small>
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="••••••"
                disabled={configuracion.id && !editar}
                value={configuracion.password || ""}
                autoComplete="off"
                onChange={(e) => {
                  setConfiguracion({ ...configuracion, password: e.target.value });
                  setAgente({ ...agente, password: e.target.value });
                }}
              />
              <small className="form-text text-muted">
                Contraseña para ingresar al sistema de telefonía
              </small>
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="correo@ejemplo.com"
                disabled={configuracion.id && !editar}
                value={agente.email || ""}
                autoComplete="off"
                onChange={(e) => {
                  setAgente({ ...agente, email: e.target.value });
                }}
              />
              <small className="form-text text-muted">
                Email para registro en la plataforma de telefonía
              </small>
            </div>

            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="estatus"
                disabled={!editar}
                checked={configuracion.estatus}
                onChange={(e) => setConfiguracion({ ...configuracion, estatus: e.target.checked })}
              />
              <label className="form-check-label" htmlFor="estatus">Estatus</label>
            </div>
          </form>

          <br />

          <button
            className={"btn btn-" + (configuracion.id && !editar ? "primary" : "danger") + " mr-3"}
            onClick={() => {
              setEditar(!editar);
              if (editar)
                getfuntion("get", "", "", API_BASE + "/" + elementos.id, "configuracion");
            }}
          >
            <Icon name={configuracion.id && !editar ? "edit" : "x"} />{" "}
            {configuracion.id && !editar ? "Editar" : "Cancelar"}
          </button>

          <button
            className="btn btn-primary"
            onClick={() => {
              if (configuracion.id) {
                getfuntion(
                  "put", agente, "",
                  API_BASE + "/actualizar_agente?provedor=" + softphonePlataforma.softphoneConfiguracionId
                    + "&id=" + elementos.id
                    + "&idPlataforma=" + softphonePlataforma.id,
                  "configuracion"
                );
              } else {
                if (softphonePlataforma && softphonePlataforma.softphoneConfiguracionId) {
                  getfuntion(
                    "post", { ...agente }, "",
                    API_BASE + "/crear_agente?provedor=" + softphonePlataforma.softphoneConfiguracionId
                      + "&id=" + elementos.id
                      + "&idPlataforma=" + softphonePlataforma.id,
                    "crear_agente"
                  );
                }
              }
            }}
          >
            <Icon name="loader" /> Guardar
          </button>
        </div>
      </div>
    </div>
  );
};

export default SoftphoneV3;
